import { FooterLinkType } from '@thenexlabs/uikit'
import { ContextApi } from 'contexts/Localization/types'

export const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
  {
    label: t('About'),
    items: [
      {
        label: t('Blog'),
        href: 'https://blog.thenex.world',
      },
      {
        label: t('What is webXR?'),
        href: '/webXR',
      },
      {
        label: t('Medium'),
        href: 'https://medium.com/@thenex.world',
      },
      {
        label: t('GLITCH'),
        href: '/glitch',
      },
      {
        label: t('XP token'),
        href: '/xp',
      },
      {
        label: '—',
      },
      {
        label: t('More NEX Links'),
        href: 'https://linktr.ee/thenex.world',
        isHighlighted: true,
      }, 
    ],
  },
  {
    label: t('Community'),
    items: [
      {
        label: t('Discord'),
        href: 'https://discord.gg/WcA3dygbwv',
      },
      {
        label: t('Youtube'),
        href: 'https://www.youtube.com/channel/UCdL8olQBqZ2328ILxGVpSqQ/',
      },
      {
        label: t('LinkedIn'),
        href: 'https://www.linkedin.com/company/nex-level-gaming',
      },
      {
        label: t('Twitter'),
        href: 'https://x.com/XPthenex',
      },
      {
        label: t('Instagram'),
        href: 'https://instagram.com/thenex.world',
      },
      {
        label: t('TikTok'),
        href: 'https://tiktok.com/@thenex.world',
      },
    ],
  },
  // {
  //   label: t('Help'),
  //   items: [
  //     {
  //       label: t('Customer Support'),
  //       href: 'https://docs.thenex.world/contact-us/customer-support',
  //     },
  //     {
  //       label: t('Troubleshooting'),
  //       href: 'https://docs.thenex.world/help/troubleshooting',
  //     },
  //     {
  //       label: t('Guides'),
  //       href: 'https://docs.thenex.world/get-started',
  //     },
  //   ],
  // },
  {
    label: t('Developers'),
    items: [
      {
        label: 'Github',
        href: 'https://github.com/thenexlabs',
      },
      // {
      //   label: t('Documentation'),
      //   href: 'https://docs.thenex.world',
      // },
      // {
      //   label: t('Bug Bounty'),
      //   href: 'https://docs.thenex.world/code/bug-bounty',
      // },
      // {
      //   label: t('Audits'),
      //   href: 'https://docs.thenex.world/help/faq#is-thenex-safe-has-thenex-been-audited',
      // },
      // {
      //   label: t('Careers'),
      //   href: 'https://docs.thenex.world/hiring/become-a-builder',
      // },
    ],
  },
]
